import { get } from '../../../api'
import { Alert, Card, Spinner } from '../../../components/ui'
import { useLoad } from '../../../hooks'
import type { AuditEntry } from '../../../types'
import { useBusiness } from '../Layout'

const ACTION_LABEL: Record<string, string> = {
  'business.created': 'Restaurant created',
  'business.updated': 'Settings changed',
  'business.public_key_rotated': 'Website key rotated',
  'business.status_changed': 'Status changed by the platform',
  'booking.created_by_staff': 'Booking taken by staff',
  'booking.moved': 'Booking moved',
  'booking.updated': 'Booking notes changed',
  'booking.seated': 'Guest seated',
  'booking.finished': 'Visit finished',
  'booking.no_show': 'Marked as no-show',
  'booking.cancelled_by_venue': 'Cancelled by the restaurant',
  'booking.cancelled_by_guest': 'Cancelled by the guest',
  'booking.approved': 'Booking approved',
  'booking.declined': 'Booking declined',
  'booking.otp_verified': 'Booking confirmed online',
  'guest.blocked': 'Guest blocked',
  'guest.unblocked': 'Guest unblocked',
}

export function AuditSection() {
  const { business } = useBusiness()
  const log = useLoad(() => get<{ entries: AuditEntry[] }>(`/v1/admin/businesses/${business.id}/audit?limit=200`), [business.id])
  return (
    <Card title="Recent activity">
      {log.loading && !log.data ? <Spinner /> : null}
      {log.error ? <Alert>{log.error}</Alert> : null}
      {log.data ? (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>When</th>
                <th>What</th>
                <th>By</th>
                <th>Detail</th>
              </tr>
            </thead>
            <tbody>
              {log.data.entries.map((e) => (
                <tr key={e.id}>
                  <td className="muted small" style={{ whiteSpace: 'nowrap' }}>
                    {new Date(e.at).toLocaleString([], { timeZone: business.timezone, day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                  </td>
                  <td>{ACTION_LABEL[e.action] ?? e.action}</td>
                  <td className="muted small">{e.actorType === 'user' ? 'staff' : e.actorType}</td>
                  <td className="muted small mono" style={{ maxWidth: 360, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {e.after ? JSON.stringify(e.after) : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </Card>
  )
}
